import { RouterModule, Routes } from "@angular/router";
import { ProductListComponent } from "./product-list/product-list.component";
import { ProductResolver } from "./resolvers/product.resolver";
import { NgModule } from "@angular/core";
import { KEEP_ON_LANGUAGE_CHANGE } from "../../Services/language.service";
import { DetailPageComponent } from "./detail-page/detail-page.component";
import { BuyNowPageComponent } from "./buy-now-page/buy-now-page.component";
import { OrderConfirmationPageComponent } from "./order-confirmation-page/order-confirmation-page.component";

/**
 * The products list keeps its filters on language change: it reloads its data in the new language itself
 * (ProductListComponent.reloadInCurrentLanguage)
 */
const PRODUCT_LIST_DATA = KEEP_ON_LANGUAGE_CHANGE;

export const ProductsRoutes: Routes = [
  {
    path: "",
    component: ProductListComponent,
    data: PRODUCT_LIST_DATA,
  },
  {
    path: "category/:id/:name",
    component: ProductListComponent,
    data: { seo: { dynamic: true }, ...PRODUCT_LIST_DATA },
  },
  {
    path: "category/:id/:name/:category/:categoryName",
    component: ProductListComponent,
    data: { seo: { dynamic: true }, ...PRODUCT_LIST_DATA },
  },
  {
    path: "brand/:brandId/:id",
    component: ProductListComponent,
    data: PRODUCT_LIST_DATA,
  },
  {
    path: "brand/:brandId",
    component: ProductListComponent,
    data: PRODUCT_LIST_DATA,
  },
  {
    path: ":name/:id/:configurationId",
    component: DetailPageComponent,
    data: { seo: { dynamic: true } },
    resolve: { detail: ProductResolver },
    // also re-fetched on a same-url reload, which MainComponent triggers on language change
    runGuardsAndResolvers: "always",
  },
  {
    path: ":name/:id/:configurationId/buy-now",
    component: BuyNowPageComponent,
    // guest order form in progress: not re-created on language change
    data: { seo: { title: "Achat rapide", noindex: true }, ...KEEP_ON_LANGUAGE_CHANGE },
    resolve: { detail: ProductResolver },
  },
  {
    path: "order-confirmation/:orderId",
    component: OrderConfirmationPageComponent,
    data: { seo: { title: "Confirmation de commande", noindex: true } },
  },
];
@NgModule({
  exports: [RouterModule],
  providers: [ProductResolver],
})
export class ProductRoutingModule {}
